let toast

const ToastPlugin = {
  install (Vue) {
    const fnForEachToastType = () => ['error', 'success'].reduce((fns, type) => ({
      ...fns,
      [type] (messageObj) {
        if (this.message) {
          return
        }

        const message = messageObj instanceof Error
          ? messageObj.response?.data?.message || messageObj.message
          : messageObj

        if (message) {
          this.message = message
          this.type = type
          this.show = true
          const delay = Math.min(Math.max(message.length * 50, 4000), 9000)
          this.timeout = setTimeout(() => {
            Object.assign(this.$data, this.$options.data())
          }, delay)
        }
      },
    }), {})

    toast = new Vue({
      data () {
        return {
          message: '',
          show: false,
          type: '',
          timeout: null,
        }
      },
      methods: {
        ...fnForEachToastType(),
        clear () {
          clearTimeout(this.timeout)
          Object.assign(this.$data, this.$options.data())
        },
      },
    })
    Vue.prototype.$toast = toast
  },
}

export {
  ToastPlugin,
  toast,
}
